import {Injectable} from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {FeatureFlagService} from '@shared/utils/feature-flag.service';

@Injectable()
export class FeatureFlagGuard  {

    constructor(
        private _router: Router,
        private _featureFlagService: FeatureFlagService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if(!route.data || !route.data["featureFlag"]) {
            return new Promise((resolve) => {resolve(false);});
        }

        let featureFlag = route.data['featureFlag'];
        let alternateRoute = route.data['alternateRoute'];

        return new Promise((resolve) => {
            this._featureFlagService.isFlagEnabled(featureFlag, {}, false)
                .then((value: boolean) => {
                    if(!value) {
                        this._router.navigate([alternateRoute || '/']);
                    }
                    resolve(value);
                });
        });
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }
}
